import IlConnectStoryLibAdapter from './IlConnectStoryLibAdapter.vue';

export function initializeIlConnectIntegration() {
  if (typeof window === 'undefined') {
    return;
  }

  if (!window.IlConnectComponentRegistry) {
    setTimeout(() => {
      initializeIlConnectIntegration();
    }, 100);
    return;
  }

  try {
    window.IlConnectComponentRegistry.register(IlConnectStoryLibAdapter);
  } catch (error) {
    // eslint-disable-next-line no-console
  }
}

export function isIlConnectIntegrationActive() {
  return (
    typeof window !== 'undefined'
    && window.IlConnectComponentRegistry
    && window.IlConnectComponentRegistry.hasComponent()
  );
}

export function unregisterIlConnectIntegration() {
  if (typeof window !== 'undefined' && window.IlConnectComponentRegistry) {
    window.IlConnectComponentRegistry.unregister();
  }
}

if (typeof window !== 'undefined') {
  setTimeout(() => {
    initializeIlConnectIntegration();
  }, 0);
}

export default {
  initializeIlConnectIntegration,
  isIlConnectIntegrationActive,
  unregisterIlConnectIntegration,
};
